export default __webpack_public_path__ + "static/media/unsolved.2fac19ae.svg";